import React from 'react';
import styled from 'styled-components';
import useStore from '~/store';
import Button from '~/components/Button';
import { views } from '~/../config.json';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
`;

const currentViewSelector = (s) => s.currentView;
const setCurrentViewSelector = (s) => s.setCurrentView;
const setLoadingSelector = (s) => s.setLoading;

export default function ViewSelect() {
  const currentView = useStore(currentViewSelector);
  const setCurrentView = useStore(setCurrentViewSelector);
  const setLoading = useStore(setLoadingSelector);

  const handleClick = (view) => {
    setLoading(true, 'left');
    setLoading(true, 'right');
    setCurrentView(view);
  };

  return (
    <ButtonGroup>
      {views.map((view) => (
        <Button style={{ fontSize: 12 }} isActive={view.id === currentView.id} onClick={() => handleClick(view)}>
          {view.description}
        </Button>
      ))}
    </ButtonGroup>
  );
}
